export default {
  amCharPbDisabled: 'AM_CHAR_PB_DISABLED',
  amCharPbCreate: 'AM_CHAR_PB_CREATE',
  amCharPb2Create: 'AM_CHAR_PB2_CREATE',
  amCharPbUpdate: 'AM_CHAR_PB_UPDATE',
  amCharPb2Update: 'AM_CHAR_PB2_UPDATE',
  amCharPbFirstSectionModal: 'AM_CHAR_PB_FIRST_SECTION_MODAL',
  amCharPbSecondSectionModal: 'AM_CHAR_PB_SECOND_SECTION_MODAL',
  amCharPbLevel: 'AM_CHAR_PB_LEVEL',
  amCharPbIcon: 'AM_CHAR_PB_ICON',
  amCharPbIconUp: 'AM_CHAR_PB_ICON_UP',
  amCharPbParent: 'AM_CHAR_PB_PARENT',
  amCharPbCode: 'AM_CHAR_PB_CODE',
  amCharPbName: 'AM_CHAR_PB_NAME',
  amCharPbEdit: 'AM_CHAR_PB_EDIT',
  amCharPb2Edit: 'AM_CHAR_PB2_EDIT',
  amCharPbDelete: 'AM_CHAR_PB_DELETE',
  amCharPb2Delete: 'AM_CHAR_PB2_DELETE',
  amCharPbLevel1: 'AM_CHAR_PB_LEVEL1',
  amCharPbLevel2: 'AM_CHAR_PB_LEVEL2',
  amCharPbLevel2Simple: 'AM_CHAR_PB_LEVEL2_SIMPLE',
  amAttributeUnit: 'AM_ATTRIBUTE_UNIT',
  amAttributeType: 'AM_ATTRIBUTE_TYPE',
  amUseAttributeInMaintenance: 'AM_USE_ATTRIBUTE_IN_MAINTENANCE',
  amUseAttributeInAlert: 'AM_USE_ATTRIBUTE_IN_ALERT',
  amAlertBefore: 'AM_ALERT_BEFORE',
  amAttributeIsCalculable: 'AM_ATTRIBUTE_IS_CALCULABLE',
  amCalculableTrue: 'AM_CALCULABLE_TRUE',
  amCalculableFalse: 'AM_CALCULABLE_FALSE',
  amCreateAttributeTitle: 'AM_CREATE_ATTRIBUTE_TITLE',
  amAttributes: 'AM_ATTRIBUTES',
  amDeleteCharPbMsg: 'AM_DELETE_CHAR_PB_MSG',
  amDeleteCharPb2Msg: 'AM_DELETE_CHAR_PB2_MSG'
}



// WEBPACK FOOTER //
// ./src/locales/agency-management/index.ts